import { useState, type ReactNode } from 'react';
import { CatalogHistoryTab, type CatalogEntityType } from './CatalogHistoryTab';

/** Shared wrapper · gives every catalog edit drawer the same Edit/History tabs.
 *  The page passes its own form as `editForm`; we render the history viewer.
 *  Keep this dumb · no business logic, just chrome.
 */
export function EditWithHistory({
  entityType,
  entityId,
  editForm,
}: {
  entityType: CatalogEntityType;
  entityId: string | undefined; // undefined when creating · history disabled
  editForm: ReactNode;
}) {
  const [tab, setTab] = useState<'edit' | 'history'>('edit');
  const canShowHistory = Boolean(entityId);

  return (
    <div>
      <div className="mb-3 flex gap-1 border-b">
        <button
          type="button"
          onClick={() => setTab('edit')}
          className={`px-3 py-1.5 text-sm font-medium transition-colors ${
            tab === 'edit'
              ? 'border-b-2 border-primary text-foreground'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          Edit
        </button>
        {canShowHistory && (
          <button
            type="button"
            onClick={() => setTab('history')}
            className={`px-3 py-1.5 text-sm font-medium transition-colors ${
              tab === 'history'
                ? 'border-b-2 border-primary text-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            History
          </button>
        )}
      </div>
      {tab === 'edit' ? editForm : (
        entityId
          ? <CatalogHistoryTab entityType={entityType} entityId={entityId} />
          : null
      )}
    </div>
  );
}
